import type { FC, HTMLAttributes, ReactNode } from "react";

interface RawHTMLWithFallbackProps extends HTMLAttributes<HTMLElement> {
	html?: string | null;
	fallback?: ReactNode;
}

export const RawHTMLWithFallback: FC<RawHTMLWithFallbackProps> = ({ html, fallback, ...divProps }) => {
	if (html) {
		return <div {...divProps} dangerouslySetInnerHTML={{ __html: html }} />;
	}
	return <div {...divProps}>{fallback}</div>;
};
